import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../api.js';
import '../styles/VenueSelection.css';

export const getVenuesList = async (user_id) => {
    try {
        const response = await api.get('/get_all_venues', { params: { user_id } });
        return response.data;
    } catch (error) {
        console.error('Fetching list of venues got error, returning empty list:', error);
        return { venues: [] };  
    }
};

function VenueSelection() {
    const [selectedVenue, setVenue] = useState('');
    const navigate = useNavigate();
    const [dataToShow, setData] = useState([]);
    const { user_id } = useParams();

    const handleVenueSelection = (event) => {
        setVenue(event.target.value);
    };

    const handleCancel = () => {
        navigate('/signin');
    };

    const handleVenueSubmission = async () => {
        try {
            const response = await api.post(
                '/select_venue',
                null,
                { params: { user_id, venue_name: selectedVenue } }
            );
            if (response.data.status === 'success') {
                navigate(`/dashboard/${user_id}`);
            }
        } catch (error) {
            console.error('Venue submission failed:', error);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            const data = await getVenuesList(user_id);
            const options = data.venues.map((val) => (
                <option key={val} value={val}>{val}</option>
            ));
            setData(options);
            if (data.venues.length > 0) {
                setVenue(data.venues[0]);
            }
        };
        fetchData();
    }, [user_id]);

    useEffect(() => {
        document.body.classList.add('venue-selection-body');
        return () => {
            document.body.classList.remove('venue-selection-body');
        };
    }, []);

    return (
        <body className="venue-selection-body">
            <div className="venue-selection-container">
                <div className="logo">BestDay2Marry</div>
                <p>What is the name of your venue?</p>
                <div className="venue_list">
                    <select onChange={handleVenueSelection} value={selectedVenue}>
                        {dataToShow}
                    </select>
                </div>
                <button type="submit" className="big-button" onClick={handleVenueSubmission}>
                    Submit
                </button>
                <button type="submit" className="medium-button" onClick={() => navigate(`/add_venue/${user_id}`)}>
                    My venue isn't here
                </button>
                <button type="button" className="small-button" onClick={handleCancel}>
                    Cancel
                </button>
            </div>
        </body>
    );
}

export default VenueSelection;